import React, { useState } from "react";
import { Select } from "./Select";
import CropImage from "./Crop";
import Upload from "./Upload";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export const ImageEditor = () => {
  const [file, setFile] = useState<string>();
  const [fileName, setFileName] = useState<string>();
  const [fileType, setFileType] = useState<string>();
  const [croppedFile, setCroppedFile] = useState<string>();
  const [aspect, setAspectRatio] = useState<number>();
  const location = useLocation();
  const handleSelectFile = (
    file: string,
    fileName: string,
    selectedFileType: string
  ) => {
    setFile(file);
    setFileType(selectedFileType);
    const state = location.state;

    let id = "";
    let fileNamePrefix = "";
    if (state.bandId) {
      id = state.bandId;
    }

    if (state.postId) {
      id = state.postId;
    }

    if (state.vendorId) {
      id = state.postId;
      fileNamePrefix = "vendors/";
    }
    
    if (state.sponsorId) {
      id = state.sponsorId;
      fileNamePrefix = "sponsors/";
    }

    if (id === "") {
      toast.error("Something went wrong, id not found");
      return;
    }

    const now = new Date().getTime()
    
    const [_, extension] = (fileName as string).split(".");

    setFileName(`${fileNamePrefix}${now}_${id}.${extension}`);
  };
  const handleCroppedFile = (file: string, aspect: number) => {
    setCroppedFile(file);
    setAspectRatio(aspect);
  };
  const navigate = useNavigate();

  const returnAction = (imageUrl: string) => {
    const state = location.state;
    let returnRoute = "";

    if (state.postId) {
      returnRoute = `/post/${state.postId}`;
    }
    if (state.bandId) {
      returnRoute = `/band/${state.bandId}`;
    }
    if (state.vendorId) {
      returnRoute = `/vendor/${state.vendorId}`;
    }
    
    if (state.sponsorId) {
      returnRoute = `/sponsor/${state.sponsorId}`;
    }

    navigate(returnRoute, {
      state: {
        updatedImageUrl: imageUrl,
        aspectRatio: aspect,
        updated: Date.now(),
      },
    });
  };

  if (!file) {
    return <Select onCompletePress={handleSelectFile} />;
  }
  if (!croppedFile)
    return (
      <CropImage
        file={file}
        sourceFileType={fileType}
        handleCroppedFile={handleCroppedFile}
      />
    );

  return (
    <Upload
      file={croppedFile}
      returnAction={returnAction}
      fileName={fileName!}
    />
  );
};
